<script lang="ts">
    import { volumeController } from './../audio/volume-controller';
    
    import { 
      Card, 
      CardText, 
      CardActions, 
      Chip, 
      Col, 
      Row, 
      Button, 
      Icon, 
      Overlay, 
      Slider 
    } from 'svelte-materialify/src';
    import { mdiVolumeHigh } from '@mdi/js';

    import { round } from '../helpers';


    let volumeMasterPercent: number, volumeBeatPercent: number, volumeSamplePercent: number;
    let volumeMasterDisplay: number, volumeBeatDisplay: number, volumeSampleDisplay;

    const stepSize: number = 0.01;
    const min: number = 0;
    const max: number = Math.ceil(1.5 / stepSize);
    const precision: number = 2;

    const realVolumeToDisplayValue = (realValue: number): number => {
      return Math.floor(realValue / stepSize);
    };
    const displayVolumeToRealValue = (displayValue: number): number => {
      return Math.round(displayValue * stepSize * 100) / 100;
    };


    let showVolumeSettings: boolean = false;
    const closeVolumeSettings = () => {
      showVolumeSettings = false;
    }


    const setNewVolumeMaster = (ev: CustomEvent) => { 
      $volumeController.gainNodeMaster.gain.value = _getRealValueFromChangeEv(ev); 
    }
    const setNewVolumeBeat = (ev: CustomEvent) => { 
      $volumeController.gainNodeBeat.gain.value = _getRealValueFromChangeEv(ev); 
    }
    const setNewVolumeSample = (ev: CustomEvent) => { 
      $volumeController.gainNodeSample.gain.value = _getRealValueFromChangeEv(ev); 
    }
    const _getRealValueFromChangeEv = (ev: CustomEvent): number => { 
      return displayVolumeToRealValue(ev.detail.value[0]); 
    };

    $: {
      volumeMasterPercent = round($volumeController.gainNodeMaster.gain.value * 100);
      volumeBeatPercent = round($volumeController.gainNodeBeat.gain.value * 100);
      volumeSamplePercent = round($volumeController.gainNodeSample.gain.value * 100);

      volumeMasterDisplay = realVolumeToDisplayValue($volumeController.gainNodeMaster.gain.value);
      volumeBeatDisplay = realVolumeToDisplayValue($volumeController.gainNodeBeat.gain.value);
      volumeSampleDisplay = realVolumeToDisplayValue($volumeController.gainNodeSample.gain.value);
    };

</script>

<style>
</style>

<Button icon title="Volume settings"
  on:click={() => { showVolumeSettings = true; }}>
  <Icon path={mdiVolumeHigh} />
</Button>

<Overlay active={showVolumeSettings} on:click={closeVolumeSettings}>
  <div on:click|stopPropagation class="volume-card">
  <Card outlined class="text-left">
    <div class="pl-4 pr-4 pt-3">
      <!-- <span class="text-overline"> OVERLINE </span><br /> -->
      <span class="text-h5 mb-2">Volume Control</span>
      <br />
    </div>
    <CardText>

      <!-- @TODO: move to sub-component -->
      <Row dense>
        <Col cols={12} sm={10}>
          <Slider value={volumeMasterDisplay} {min} {max} {precision} step={stepSize} on:change={setNewVolumeMaster}>
            Master
          </Slider>
        </Col>   
        <Col cols={12} sm={2}>
          <Chip label>{volumeMasterPercent}%</Chip>
        </Col>     
      </Row>
      
      <Row dense>
        <Col cols={12} sm={10}>
          <Slider value={volumeBeatDisplay} {min} {max} {precision} step={stepSize} on:change={setNewVolumeBeat}>
            Beat
          </Slider>
        </Col>
        <Col cols={12} sm={2}>
          <Chip label>{volumeBeatPercent}%</Chip>
        </Col>
      </Row>

      <Row dense>
        <Col cols={12} sm={10}>
          <Slider value={volumeSampleDisplay} {min} {max} {precision} step={stepSize} on:change={setNewVolumeSample}>
            Sample
          </Slider>
        </Col>
        <Col cols={12} sm={2}>
          <Chip label>{volumeSamplePercent}%</Chip>
        </Col>
      </Row>


    </CardText>
    <CardActions>
      <Button rounded outlined  on:click={closeVolumeSettings}>Done</Button>
    </CardActions>
  </Card>
  </div>

</Overlay>